import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPortfolioComponent } from './mat-portfolio/mat-portfolio.component'
export interface GalleryImg {
  comment1: any;
  img: string;
}
export interface tabHeading {
  img: string;
  redirectURL: string;
  id: string;
  ariacontrols: string;

}
@Component({
  selector: 'app-service-portfolio',
  templateUrl: './service-portfolio.component.html',
  styleUrls: ['./service-portfolio.component.less']
})
export class ServicePortfolioComponent implements OnInit {

  selected: any;
  imagesData_17: object = [
    {
      id: 0,
      img: '../../../assets/images/gallery/services-img/services-port/k1.png',
      name: 'Perfect Fit School Uniforms'
    },
    {
      id: 1,
      img: '../../../assets/images/gallery/customkurtadesign/trendy kurta-12.png',
      name: "Trendy kid's kurta set"
    },
    {
      id: 2,
      img: '../../../assets/images/gallery/services-img/services-port/k5.png',
      name: 'Restyling Saree To Frock'

    },
    {
      id: 3,
      img: '../../../assets/images/gallery/services-img/services-port/k4.png',
      name: 'Skirt'
    },

  ];
  imagesData_18: object = [
    {
      id: 0,
      img: '../../../assets/images/gallery/services-img/services-port/a1.png',
      name: 'Perfect Fit Bottom'
    },
    {
      id: 1,
      img: '../../../assets/images/gallery/services-img/services-port/a2.png',
      name: 'Custom Styled Kurta'
    },
    {
      id: 2,
      img: '../../../assets/images/gallery/services-img/services-port/a3 (2).png',
      name: 'Customized Blouse'
    },
  ];
  imagesData_19: object = [
    {
      id: 0,
      img: '../../../assets/images/gallery/services-img/services-port/e1.png',
      name: 'Ethnic wear outfit'
    },
    {
      id: 1,
      img: '../../../assets/images/gallery/services-img/services-port/e2.png',
      name: 'Custom Made Anarkali'
    },
    {
      id: 2,
      img: '../../../assets/images/gallery/services-img/services-port/e3.png',
      name: 'Frock'
    },

  ];
  imagesData_20: object = [
    {
      id: 0,
      img: '../../../assets/images/gallery/services-img/services-port/tb1.png',
      name: 'Trendy Pants'
    },
    {
      id: 1,
      img: '../../../assets/images/gallery/services-img/services-port/tb2.png',
      name: 'Custom made Kurta '
    },
    {
      id: 2,
      img: '../../../assets/images/gallery/services-img/services-port/tb3.png',
      name: 'Latest kurta Design'
    },
    {
      id: 3,
      img: '../../../assets/images/gallery/services-img/services-port/tb4.png',
      name: 'Prince Cut Kurta'
    },
    {
      id: 4,
      img: '../../../assets/images/gallery/services-img/services-port/tb5.png',
      name: 'Georgete Embrided Kurta Top'
    },
    {
      id: 5,
      img: '../../../assets/images/gallery/services-img/services-port/tb6.png',
      name: 'Trendy kurta Design'
    },

  ];
  imagesData_21: object = [

    {
      id: 0,
      img: '../../../assets/images/gallery/trendy blouse/service-b1.png',
      name: 'Prince Cut Blouse'
    },

    {
      id: 1,
      img: '../../../assets/images/gallery/trendy blouse/service-b2.png',
      name: 'Trendy Blouse Design'
    },
    {
      id: 2,
      img: '../../../assets/images/gallery/trendy blouse/service-b3.png',
      name: 'Aari Work Blouse Design'
    },
    {
      id: 3,
      img: '../../../assets/images/gallery/trendy blouse/service-b4.png',
      name: 'unique & stunning Bridal Blouse Design'
    },
    {
      id: 4,
      img: '../../../assets/images/gallery/trendy blouse/service-b5.png',
      name: 'Embroidered Lace & Trims Saree Boreder And Blouse'
    },
    {
      id: 5,
      img: '../../../assets/images/gallery/trendy blouse/service-b6.png',
      name: 'Unique & Stunning Bridal'
    }
  ];

  imagesData_22: object = [
    {
      id: 0,
      img: '../../../assets/images/gallery/services-img/services-port/j2.png',
      name: 'Handmade Earings '
    },
    {
      id: 1,
      img: '../../../assets/images/gallery/services-img/services-port/j3.png',
      name: ' Jhumka Earings '
    },
    {
      id: 2,
      img: '../../../assets/images/gallery/services-img/services-port/j4.png',
      name: 'Necklace'
    },
    {
      id: 3,
      img: '../../../assets/images/gallery/services-img/services-port/j1.png',
      name: ' Bangles'
    },

  ];
  selectedMenu: tabHeading;
  customTab: any;
  constructor(public dialog: MatDialog) { }
  ngOnInit() {
    let tab_value = localStorage.getItem("tab_value");
    this.customTab = Number(tab_value);
    if (tab_value != null) {
      this.scrollWin();
    }
    localStorage.removeItem("tab_value")
  }
  index: any;
  carosuals_data: any = this.imagesData_21;
  selectTab(event) {
    if (event.index == 0) {
      this.carosuals_data = this.imagesData_21;
    } else if (event.index == 1) {
      this.carosuals_data = this.imagesData_20;
    } else if (event.index == 2) {
      this.carosuals_data = this.imagesData_19;
    } else if (event.index == 3) {
      this.carosuals_data = this.imagesData_18;
    } else if (event.index == 4) {
      this.carosuals_data = this.imagesData_17;
    } else if (event.index == 5) {
      this.carosuals_data = this.imagesData_22;
    }
  }
  openDialog(i: any, carousals): void {
    let imgIndex = i;
    let current_img = carousals.img;
    const dialogRef = this.dialog.open(MatPortfolioComponent, {
      width: '550px',
      height: '500px',
      // overflow:'32',
      data: { imgIndex: imgIndex, carousals_data: this.carosuals_data, current_img: current_img }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(' The dialog closed');
    });
  }



  listClick(event: any, menu: tabHeading) {
    this.selectedMenu = menu;
  }
  scrollWin() {
    window.scrollTo(0, 620);
  }
}

